import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_CATEGORY_NAMES = gql`
  query Get($type: String!) {
    getCategoryNames(search: $type) {
      postName
    }
  }
`;
/*postDescription {
          title {
              en
          }
      }*/
const getCategoryNames = async (type) => {
  try {
    const result = await client
      .query({
        query: GET_CATEGORY_NAMES,
        variables: { type },
        errorPolicy: 'all',
        fetchResults: true,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getCategoryNames: postsByTypeData },
    } = result;

    if (postsByTypeData) {
      return postsByTypeData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getCategoryNames = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getCategoryNames Error: ${error}`);
    return null;
  }
};

export default getCategoryNames;
